export const INPUT_TYPES = {
  TEXT: 'text',
  DATE: 'date',
  DROPDOWN: 'dropdown'
};
